import React from 'react';
import {Icon, Flex} from 'components';

export function IconText({ name, className, children, icon = { name } }) {
  return (
    <Flex className={['small-gutter', 'inline', className]}>
      { icon && <Icon {...icon} /> }
      { children }
    </Flex>
  );
}
